// extracted by mini-css-extract-plugin
export default {"Icon":"IconForecast_Icon__3Qt2H"};